<template>
  <base-modal
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Save"
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="justify-between"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="mb-4"><label for="title" class="block text-[13px] font-medium text-ink mb-1.5">Title</label>
        <textarea
          id="title"
          v-model="bodyRequirement.title"
          required
          placeholder=""
          rows="1"
          max-rows="10"
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
        ></textarea>
      </div>

      <div class="mb-4"><label for="category" class="block text-[13px] font-medium text-ink mb-1.5">Category</label>
        <base-select v-model="bodyRequirement.category" :options="requirementTypes" value-key="value" label-key="text" placeholder="Select category"></base-select>
      </div>

      <div class="mb-4"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Application type</label>
        <base-select v-model="bodyRequirement.type" :options="applicationTypes" value-key="value" label-key="text" placeholder="Select type"></base-select>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import BaseSelect from '../../UIComponents/BaseSelect'

export default {
  components: { BaseSelect },
  props: ['item', 'body', 'bodySlug', 'requirementIndex'],
  data () {
    return {
      bodyRequirement: {
        title: '',
        createdAt: '',
        type: 'promise',
        category: ''
      },
      requirements: []
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.auth.statusOptions,
      applicationTypes: state => state.auth.applicationTypes,
      requirementTypes: state => state.auth.requirementTypes
    }),
    title () {
      if (this.item) {
        return 'Edit requirement'
      } else {
        return 'Add requirement'
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      this.requirements[this.requirementIndex] = this.bodyRequirement
      const { bodyRequirement, bodySlug, requirements } = this
      if (this.item) {
        this.$store.dispatch('UPDATE_BODY_REQUIREMENT', { bodySlug, requirements }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      } else {
        this.bodyRequirement.createdAt = dayjs().format()
        this.$store.dispatch('ADD_BODY_REQUIREMENT', { bodySlug, bodyRequirement }).then((response) => {
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        })
      }
    },
    resetModal () {
      this.bodyRequirement.title = ''
      this.bodyRequirement.createdAt = ''
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.bodyRequirement.title = this.item.title
        this.bodyRequirement.createdAt = this.item.createdAt
        this.bodyRequirement.type = this.item.type ? this.item.type : 'promise'
        this.bodyRequirement.category = this.item.category ? this.item.category : ''
        this.requirements = this.body.requirements
      }
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>